import React, { Component } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";

import {
  sortNumeric,
  selectFormat,
  TableContentCell,
  getMetricForColumn,
  MetricTable,
  Error,
} from "components/Utils/Utils.js";
import Uri from "jsuri";

const metricFormatter = (cell, row, rowIndex, enumObject) => {
  const props = { ...cell, ...enumObject };
  return <MetricTable {...props} />;
};

class TopContent extends Component {
  componentDidMount() {
    this.props.childRef(this);
    this.props.passRefUpward(this.childRef);
  }

  renderTable(data) {
    const { cells, title, url } = this.props;

    const columns = [
      {
        dataField: "title",
        text: "Title",
        style: { width: "320px", minWidth: "320px", textAlign: "left" },
        headerAlign: "left",
        formatter: TableContentCell,
        formatExtraData: {
          name: url.split("/")[2],
        },
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
        sort: true,
      },
      {
        dataField: "views",
        text: "Views",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "views_unique",
        text: "Views Unique",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "avg_view_time",
        text: "Avg View Time",
        style: { width: "120px", minWidth: "120px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "first_views",
        text: "1st Time Viewers",
        style: { width: "120px", minWidth: "120px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "sessions_with_purchase",
        text: "Sessions with a Purchase",
        style: { width: "180px", minWidth: "180px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "attributed_revenue",
        text: "Attributed Revenue",
        style: { width: "130px", minWidth: "130px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "pct_of_first_views_that_purchase",
        text: "Purchase % ",
        style: { width: "130px", minWidth: "130px" },
        formatter: metricFormatter,
        formatExtraData: { type: "percentage", format: "0.00%" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "%0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "purchase_pct",
        text: "1st Time Purchaser %",
        style: { width: "150px", minWidth: "150px" },
        formatter: metricFormatter,
        formatExtraData: { type: "percentage", format: "0.00%" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "%0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "viewers",
        text: "Unique Viewers",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "time_watched",
        text: "Min Time Watched",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "free_trial_viewers",
        text: "Free Trial Viewers",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "free_trial_time_watched",
        text: "FT Min Watched",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
    ];

    /**
     * Columns that may belong to different tenants and may be unique (concated with `columns`) to be
     * used when cells being defined in the tenant config
     */
    const extraColumns = [
      {
        dataField: "brand_title",
        text: "Title",
        style: { width: "320px", minWidth: "320px", textAlign: "left" },
        headerAlign: "left",
        formatter: TableContentCell,
        formatExtraData: {
          name: url.split("/")[2],
        },
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
        sort: true,
      },
      {
        dataField: "block_title",
        text: "Title",
        style: { width: "320px", minWidth: "320px", textAlign: "left" },
        headerAlign: "left",
        formatter: TableContentCell,
        formatExtraData: {
          name: new Uri(url).hasQueryParam("p")
            ? new Uri(url).getQueryParamValue("p")
            : url.split("/")[2],
        },
        sort: true,
      },
      {
        dataField: "rev_share_views",
        text: "Rev Share Views",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "rev_share_view_time",
        text: "Rev Share View Time",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "view_time",
        text: "View Time",
        style: { width: "105px", minWidth: "105px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
    ];

    const pagination = paginationFactory({
      sizePerPage:
        [
          "/dashboard/pocket-watch/watching-top-content?t=last30&type=top-creators",
        ].indexOf(url.toLowerCase()) > -1
          ? 10
          : 15,
      hideSizePerPage: true,
    });

    const defaultSorted = [
      {
        dataField: "views",
        order: "desc",
      },
    ];

    let selected_columns = columns;
    if (cells && cells.length) {
      const compositeColumns = [...columns, ...extraColumns];
      selected_columns = [];
      cells.forEach((cell, i) => {
        selected_columns.push(
          compositeColumns.find((o) => o.dataField === cell)
        );
      });
    }

    const filename = title.split(" ").join("_") || "spreadsheet";
    return (
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={selected_columns}
        striped={false}
        hover={false}
        bordered={false}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: true,
          onlyExportSelection: false,
        }}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            defaultSorted={defaultSorted}
            pagination={pagination}
            filter={filterFactory()}
            ref={(el) => (this.childRef = el)}
          />
        )}
      </ToolkitProvider>
    );
  }

  builtInExportCSV = () => this.childRef;

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    data.data.forEach((d, i) => {
      d.id = i;
      d.title = d.title || d.brand_title;
    });

    return this.renderTable(data.data);
  }
}

export default TopContent;
